import React from 'react';
import { number, oneOfType, string } from 'prop-types';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import { UNLIMITED_REVISION } from '../../../utils/packagesUtils/constants';

const NumberedPricingFactor = ({ value }) => (
    <td>
        {value === UNLIMITED_REVISION ? <I18n k="gig_page_perseus.packages.unlimited"/> : value}
    </td>
);

NumberedPricingFactor.propTypes = {
    value: oneOfType([number, string])
};

export default NumberedPricingFactor;
